import { gql } from '@apollo/client';

export const MarkViewedChatMessagesMutation = gql`
    mutation MarkViewedChatMessages($ids: [ID!]!) {
        markViewedChatMessages(ids: $ids)
    }
`;
